"use client";
import React from "react";

type LoadingProps = {
  loadingText?: string;
  showLoadingText?: boolean;
};

const Loading = ({
  loadingText = "Loading...",
  showLoadingText = true,
}: LoadingProps) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="relative flex items-center justify-center group">
        {/* Spinner Ring */}
        <div className="absolute h-16 w-16 rounded-full border-8 border-t-transparent border-r-yellow-500 border-b-blue-500 border-l-purple-500 animate-spin"></div>

        {/* Pulsing Center */}
        <div className="h-8 w-8 bg-gradient-to-r from-yellow-500 via-blue-500 to-purple-500 rounded-full animate-pulse shadow-lg transition-transform duration-300 group-hover:scale-110"></div>

        {/* Animated Text */}
        {showLoadingText && (
          <span className="absolute top-full mt-6 text-lg poppins-medium text-yellow-400 animate-fadeInOut">
            {loadingText}
          </span>
        )}
      </div>

      {/* Custom CSS for Animations */}
      <style jsx>{`
        @keyframes fadeInOut {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
        .animate-fadeInOut {
          animation: fadeInOut 1.5s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Loading;